// @ts-check
import { Tooltip } from '@material-ui/core';
import Text from './base/Text';
import Icon from 'components/base/Icon';
import { Padding } from './base/layout-components';
import { LBButton } from '@linearb/buzz';

const BoldedValue = ({
  value,
  description,
  boldedValueTooltipTitle,
  boldedValueIcon = (
    <LBButton variant='ghost' size='icon'>
      <Icon name='infooutlined' size='smaller' color='nepal' />
    </LBButton>
  ),
  cursor,
  dataCy = '',
  color = 'shuttleGray',
  ...rest
}) => {
  return (
    <div className='flex flex-row items-center'>
      <div className='flex flex-row items-center' {...rest}>
        <Text
          data-cy={dataCy.replace(/\s+/g, '-')}
          cursor={cursor}
          pr='0.5rem'
          weight='bold'
          size={value.size}
          color={color}
        >
          {value.text}
        </Text>
        {description && (
          <Text
            cursor={cursor}
            color={color}
            size={description.size}
            multiLineEllipsisAfter={2}
          >
            {description.text}
          </Text>
        )}
      </div>
      {boldedValueTooltipTitle && (
        <Padding l='x-small'>
          <Tooltip
            title={boldedValueTooltipTitle}
            data-cy='bolded-value-tooltip'
          >
            {boldedValueIcon}
          </Tooltip>
        </Padding>
      )}
    </div>
  );
};

export default BoldedValue;
